import React from "react";

const SvgCrossWhite = props => <svg fill="none" viewBox="0 0 14 14" {...props}><path d="M13 1L1 13M1 1l12 12" stroke="#fff" strokeLinecap="square" /></svg>;

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAxNCI+PHBhdGggZD0iTTEzIDFMMSAxM00xIDFsMTIgMTIiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPjwvc3ZnPg==";
export { SvgCrossWhite as ReactComponent };